<template>
  <SfModal v-if="showModal" size="xs" @close="closeModal">
    <template #title>{{ titleLabel }}</template>

    <template #body>
      <div class="sf-level sf-level-between sf-below-1">
        <label class="sf-form-check sf-form-check-rounded sf-inline-block">
          <input v-model="changeThisPeriodOnly" type="radio" value="true" />
          <span class="sf-form-check-content sf-level">
            <span class="sf-form-check-indicator" />
            <span>{{ radioOptionCurrentPeriodLabel }}</span>
          </span>
        </label>
      </div>
      <div class="sf-level sf-level-between sf-below-1">
        <label class="sf-form-check sf-form-check-rounded sf-inline-block">
          <input v-model="changeThisPeriodOnly" type="radio" value="false" />
          <span class="sf-form-check-content sf-level">
            <span class="sf-form-check-indicator" />
            <span>{{ radioOptionCurrentAndFollowingPeriodsLabel }}</span>
          </span>
        </label>
      </div>
    </template>

    <template #footer>
      <SfButtonDs @click="closeModal">{{ cancelButtonLabel }}</SfButtonDs>
      <SfButtonDs
        variant="primary"
        :disabled="changeThisPeriodOnly === null"
        data-heap="periodic-to-do-edit"
        @click="save"
      >
        {{ saveButtonLabel }}
      </SfButtonDs>
    </template>
  </SfModal>
</template>

<script type="text/javascript">
import { SfButtonDs } from '@silverfin/ui-components'
import { SfModal } from '@app/shared/vue/components/sf-modal'

export default {
  name: 'PeriodScopeForUpdateModal',
  components: {
    SfButtonDs,
    SfModal,
  },
  setup() {
    return {
      titleLabel: I18n.t('communication.period_scope_for_update_modal.title'),
      radioOptionCurrentPeriodLabel: I18n.t(
        'communication.period_scope_for_update_modal.current_period'
      ),
      radioOptionCurrentAndFollowingPeriodsLabel: I18n.t(
        'communication.period_scope_for_update_modal.current_and_following_periods'
      ),
      cancelButtonLabel: I18n.t('common.cancel'),
      saveButtonLabel: I18n.t('common.save_changes'),
    }
  },
  data() {
    return {
      showModal: true,
      changeThisPeriodOnly: null,
    }
  },
  methods: {
    openModal({ onConfirm }) {
      this.showModal = true
      this.onConfirm = onConfirm
    },
    closeModal() {
      this.showModal = false
    },
    save() {
      this.onConfirm(this.changeThisPeriodOnly === 'true')
      this.closeModal()
    },
  },
}
</script>
